import { BehaviorSubject } from 'rxjs';
export const getCreateCalculationFormStore = () => {
    const getInitialState = () => ({
        calculationClientDetails: [],
        isLoadingClientDetails: true,
        selectedClient: {
            clientId: null,
            clientName: '',
            companyRelatedDetails: []
        }
    });
    const createCalculationFormSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => createCalculationFormSubject.subscribe(callback);
    const setIsLoadingClientDetails = (isLoadingClientDetails) => createCalculationFormSubject.next({
        ...createCalculationFormSubject.getValue(),
        isLoadingClientDetails
    });
    const calculationClientDetailsFetchSuccess = (calculationClientDetails) => {
        createCalculationFormSubject.next({
            ...createCalculationFormSubject.getValue(),
            isLoadingClientDetails: false,
            calculationClientDetails
        });
    };
    const setSelectedClient = (clientId) => {
        const client = createCalculationFormSubject
            .getValue()
            .calculationClientDetails.find((item) => item.clientId === clientId);
        createCalculationFormSubject.next({
            ...createCalculationFormSubject.getValue(),
            selectedClient: client
        });
    };
    const reset = () => createCalculationFormSubject.next(getInitialState());
    return {
        getInitialState,
        setIsLoadingClientDetails,
        calculationClientDetailsFetchSuccess,
        setSelectedClient,
        reset,
        subscribe
    };
};
